<template>
  <div class="timer-line-container" :class="[color]">
    <div
        v-if="timeStatic !== -1"
        class="timer-line-content"
        @animationend="animationend"
        :style="{ '--fill-percentage': `${progress}%`,
        '--timer': `${timeStatic}s` }"
    ></div>
  </div>
</template>

<script>
export default {
  name: "LineTimer",
  props: {
    color: {
      type: String,
      default: 'green'
    },
    time: {
      type: Number,
      required: false,
      default: 30 //время в секундах, которое осталось пройти по таймеру
    },
    timeDefault: {
      type: Number,
      default: 30 //время в секундах для таймера
    }
  },
  data() {
    return {
      progress: 100,
      timeStatic: -1
    };
  },
  mounted() {
    this.timeStatic = this.time
    this.startTimer();
  },
  methods: {
    startTimer() {
      this.progress = (this.time * 100) / this.timeDefault;
    },
    animationend() {
      this.$emit('animationend')
    }
  }
}
</script>

<style scoped lang="scss">
.timer-line-container {
  width: 100%;
  height: 2px;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  background-color: var(--color-purple);
  .timer-line-content {
    background-color: var(--color-white);
  }

}

.timer-line-content {
  height: 100%;
  width: 0;
  position: absolute;
  top: 0;
  left: 0;
  animation: animateText linear var(--timer) forwards;

}
@keyframes animateText {
  from {
    width: 0;
  }
  to {
    width: var(--fill-percentage);
  }
}
</style>